import React from "react";

import ListItem from "./ListItem";

import "./style.scss";

function List({
  selectable,
  data = [],
  onItemSelect,
  selectedItem,
  getTitle,
  getIsSelected,
  disabled,
  parentID,
  onUpdate,
  isActivities = false,
}) {
  function onValueChange(id, newValue) {
    const newData = data?.map((e) => {
      if (e?.ID === id) return { ...e, Weight: newValue };

      return e;
    });
    onUpdate(newData, parentID, isActivities);
  }

  return (
    <div className="weight-kpis__list">
      {data?.map((e) => (
        <ListItem
          key={e?.ID}
          selectable={selectable}
          item={e}
          title={getTitle ? getTitle(e) : e?.Title}
          value={e?.Weight}
          onValueChange={onValueChange}
          onItemSelect={onItemSelect}
          disabled={disabled}
          isSelected={
            getIsSelected ? getIsSelected(e) : selectedItem?.ID === e?.ID
          }
        />
      ))}
    </div>
  );
}

export default List;
